<script lang="ts">
    import { spaLink } from "../../../actions"
    import Icon from "../../Icon.svelte"
    const arrowRight =
        "M18.256 23.0773L17.3133 22.1173L22.764 16.6666H6.66667V15.3333H22.764L17.3133 9.88261L18.256 8.92261L25.3333 15.9999L18.256 23.0773Z"
    export let path = "",
        white = false,
        onClick: () => void = () => {}
</script>

{#if path}
    <button class:white>
        <a href="{path}" use:spaLink>
            <span>
                <Icon path="{arrowRight}" size="32px" viewBox="0 0 32 32" />
            </span>
            <span>
                <slot></slot>
            </span>
        </a>
    </button>
{:else}
    <button class:white on:click="{onClick}">
        <div class="wrapper">
            <span>
                <Icon path="{arrowRight}" size="32px" viewBox="0 0 32 32" />
            </span>
            <span>
                <slot></slot>
            </span>
        </div>
    </button>
{/if}

<style lang="less">
    button {
        border-radius: 200px;
        background: var(--blue-100);
        border: none;
        height: 28px;
        width: fit-content;
        padding: 2px 18px 2px 6px;
        transition:
            gap 0.3s ease-out,
            background 0.3s ease-out,
            color 0.3s ease-out;
        a,
        div.wrapper {
            width: 100%;
            display: flex;

            text-decoration: none;
            width: fit-content;
            height: 100%;
            align-items: center;
            gap: 6px;
            color: var(--white-100);
            transition:
                gap 0.3s ease-out,
                background 0.3s ease-out,
                color 0.3s ease-out;
            span {
                display: flex;
                align-items: center;
            }
        }

        &.white {
            height: 36px;
            background: var(--white-100);
            color: var(--blue-100);
            a {
                color: var(--blue-100);
                span {
                    font-size: 1rem;
                }
            }
        }
        &:hover {
            background: var(--orange-100);
            a,
            div.wrapper {
                color: white;
                gap: 0px;
            }
        }
    }
</style>
